<div class="tab-content" [class.loading]="loadingSettings">
  @if (loadingSettings) {
    <svg lucideLoaderCircle class="tab-loading-spinner lucide-spin"></svg>
  }
  @if (!loadingSettings) {
    <p class="double-margin-bottom">
      Your Retention Policy determines how many recovery points Arpio retains across your account, on a rolling basis.
      Any retained recovery points can be selected for a recovery. Recovery Points will be deleted as they age out of
      this policy. <a href="{{ uiService.retentionDocsUrl }}">Learn More</a>
    </p>
    <form [formGroup]="retentionSettingsFormModel" (ngSubmit)="updateRetentionSettings()">
      <div class="margin-top">
        Always retain the
        <input
          id="recent-retained"
          class="arpio-input right-align"
          formControlName="recentRetained"
          size="3"
          focus-element
        />
        most recent recovery points.
      </div>
      <div class="margin-top">
        Also retain 1 recovery point per day for the
        <input id="days-retained" class="arpio-input right-align" formControlName="daysRetained" size="3" />
        most recent days.
      </div>
      <div class="margin-top">
        Also retain 1 recovery point per week for the
        <input id="weeks-retained" class="arpio-input right-align" formControlName="weeksRetained" size="3" />
        most recent weeks.
      </div>
      <div class="margin-top">
        Also retain 1 recovery point per month for the
        <input id="months-retained" class="arpio-input right-align" formControlName="monthsRetained" size="3" />
        most recent months.
      </div>
      <div class="margin-top">
        Also retain 1 recovery point per quarter for the
        <input id="quarters-retained" class="arpio-input right-align" formControlName="quartersRetained" size="3" />
        most recent quarters.
      </div>
      @if (canManageRetentionPolicy) {
        <button
          busy-button
          [busy]="submitting"
          [done]="doneSubmitting"
          type="submit"
          id="update-retention-policy-button"
          class="arpio-button margin-top"
          [disabled]="updateButtonDisabled"
          (click)="updateRetentionSettings()"
        >
          Update
        </button>
      }
    </form>
  }

  <modal-dialog #releaseRpsDialog [dialogTemplate]="releaseRpsDialogTemplate"></modal-dialog>

  <ng-template #releaseRpsDialogTemplate>
    <div class="flex-center-column full-width">
      <confirm-action-dialog
        action="Release"
        name="Recovery Points"
        dialogId="release-recovery-points-confirm"
        (onCancel)="dismissReleaseModal()"
        (onAction)="unprotectRps()"
        [busy]="unprotecting"
      >
        <div class="error margin-top">
          Note: After the Recovery Points are released they are eligible for clean up and may be deleted by
          {{ productName }}
        </div>
      </confirm-action-dialog>
    </div>
  </ng-template>

  @if (showRetainedRps) {
    <h2 class="margin-top">Indefinitely-Retained Recovery Points</h2>
    <p>These Recovery Points are exempt from clean up even if they don't match the retention policy.</p>
    <div class="card flex justify-content-center table-container" style="max-width: 60rem">
      <!-- size="small" is the supported compact-density input. The old arpio-table class is dropped rather than moved
           to tableStyleClass: table.arpio-table only ever matched plain <table> elements, so it never applied here. -->
      <p-table
        #dt1
        [value]="retainedRps"
        sortField="applicationName"
        sortMode="multiple"
        selectionMode="multiple"
        [(selection)]="selectedRps"
        [globalFilterFields]="globalFilterFields"
        dataKey="rp.recoveryPointId"
        [scrollable]="true"
        scrollHeight="flex"
        [resizableColumns]="true"
        [tableStyle]="{ 'min-width': '30rem', 'max-width': '60rem' }"
        size="small"
        [rowHover]="true"
        [totalRecords]="retainedRps?.length ?? 0"
        [paginator]="true"
        overflow="auto"
        [showLoader]="false"
        [loading]="loadingRetainedRps"
        [rows]="25"
        [rowsPerPageOptions]="[25, 50, 100]"
      >
        <ng-template #loadingbody>
          <tr>
            <td><p-skeleton /></td>
            <td><p-skeleton /></td>
            <td><p-skeleton /></td>
          </tr>
          <tr>
            <td><p-skeleton /></td>
            <td><p-skeleton /></td>
            <td><p-skeleton /></td>
          </tr>
        </ng-template>
        <ng-template #caption>
          <div class="flex-row flex-center-row retention-caption-controls">
            @if (canManageRetentionPolicy) {
              <p-button
                pRipple
                severity="danger"
                (click)="releaseRpsClick()"
                [label]="releaseButtonText"
                [disabled]="unprotectDisabled"
              >
                <ng-template #icon>
                  <svg lucideLockOpen></svg>
                </ng-template>
              </p-button>
            }
            <p-iconfield class="filter-container" iconPosition="right">
              <input
                pInputText
                #filterInput
                type="text"
                class="input-small"
                (input)="dt1.filterGlobal($event.target.value, 'contains')"
                placeholder="Filter..."
              />
              <p-inputicon>
                <svg lucideFunnel class="fade-icon"></svg>
              </p-inputicon>
            </p-iconfield>
          </div>
        </ng-template>
        <ng-template #header>
          <tr>
            <!-- PrimeNG dropped the camelCase element selectors, so these tags must stay kebab-case or they
                 silently match no component and the column renders empty. -->
            <th style="width: 4rem"><p-table-header-checkbox /></th>
            <th pSortableColumn="applicationName" class="strong-text">
              <div class="strong-text">Application <p-sort-icon field="applicationName"></p-sort-icon></div>
            </th>
            <th pSortableColumn="timestampString" class="strong-text">
              <div class="strong-text">Timestamp <p-sort-icon field="timestampString"></p-sort-icon></div>
            </th>
          </tr>
        </ng-template>
        <ng-template #body let-rpr>
          <tr>
            <td>
              <p-table-checkbox [value]="rpr" />
            </td>
            <td>
              <span>{{ rpr.applicationName }}</span>
            </td>
            <td>
              <span>{{ rpr.timestampString }}</span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }
</div>
